import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Radio } from "lucide-react";

export default function RightRail() {
  const [live, setLive] = useState([]);
  const [communities, setCommunities] = useState([]);

  useEffect(() => {
    api.get("/live").then(({ data }) => setLive(data)).catch(() => {});
    api.get("/communities").then(({ data }) => setCommunities(data.slice(0, 5))).catch(() => {});
  }, []);

  return (
    <aside className="lg:col-span-3 lg:sticky lg:top-0 lg:h-screen py-8 pl-4 hidden lg:block overflow-y-auto">
      <div className="mb-8">
        <div className="flex items-center gap-2 mb-4">
          <span className="w-2 h-2 rounded-full bg-rose-600 pulse-dot" />
          <h3 className="text-xs uppercase tracking-[0.3em] text-zinc-400">Live Now</h3>
        </div>
        {live.length === 0 && (
          <div className="text-sm text-zinc-500">No one is live. Be the first.</div>
        )}
        <div className="flex flex-col gap-3">
          {live.map((s) => (
            <Link
              to="/live"
              key={s.id}
              className="card-surface p-3 flex items-center gap-3 hover-lift"
            >
              <Avatar className="w-10 h-10 border border-rose-600/50">
                <AvatarImage src={s.host?.avatar_url} />
                <AvatarFallback className="bg-rose-600 text-white text-sm">
                  {s.host?.display_name?.[0]?.toUpperCase() || "L"}
                </AvatarFallback>
              </Avatar>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-medium truncate">{s.title || "Untitled Live"}</div>
                <div className="text-xs text-zinc-500 truncate">
                  {s.host?.display_name} · {s.viewer_count} watching
                </div>
              </div>
              <Radio size={14} className="text-rose-600" />
            </Link>
          ))}
        </div>
      </div>

      <div>
        <h3 className="text-xs uppercase tracking-[0.3em] text-zinc-400 mb-4">Trending Communities</h3>
        <div className="flex flex-col gap-2">
          {communities.map((c) => (
            <Link
              key={c.id}
              to="/communities"
              className="flex items-center justify-between px-3 py-3 border-l-2 border-transparent hover:border-rose-600 hover:bg-white/[0.02] transition-colors"
            >
              <div>
                <div className="text-sm font-medium">{c.name}</div>
                <div className="text-xs text-zinc-500">{c.members_count.toLocaleString()} members</div>
              </div>
              <span className="text-xs text-rose-500">Explore →</span>
            </Link>
          ))}
        </div>
      </div>

      <div className="mt-10 text-[10px] uppercase tracking-[0.3em] text-zinc-600">
        © My Panda X · mypandax.com · 18+
      </div>
    </aside>
  );
}
